<template>
  <div class="content-box">
    <img :src="getPicLink('index_bg.jpg')" width="100%" alt="" class="bg_img">
    <div class="content" ref="nav0">
      <div class="head_nav">
        <img :src="getPicLink('logo.png')" alt="" class="logo">
        <div class="nav-btn-outer">
          <div class="nav" v-for="(item, index) in navs" :class="[`nav_${index}`,{'nav_focus': index === navFocusFlag}]"
               @mouseenter.stop="navFocus(index)" @mouseleave.stop="navFocus(-1)" @click.stop="scrollDom(index)">
              {{item}}
          </div>
        </div>
      </div>
      <div class="webTitle"></div>
      <div class="rightSides">
        <img src="~img/rightSides.png" alt="" class="bg">
        <img src="~img/gzhCode.jpg" alt="" class="erweima">
      </div>
      <div class="download">
        <div class="download_ercode"></div>
        <div class="downloadBtn" v-for="(item, index) in outLink.download"
             :class="[{'hoverDownload': hoverDownload === item}]"
             @mouseenter.stop="enterDownload(item)"
             @mouseleave.stop="enterDownload('')"
             @click.stop="clickBooking(item)"></div>
      </div>
      <div class="bookProgress">
        <div class="levels">
          <div v-for="(item, index) in bookProgress" :class="`level level${item.num}`">
<!--            <img :src="getPic(item.pic,'png')" width="100%" alt="">-->
          </div>
        </div>
        <div class="progressLine">
          <div class="line-box">
            <div class="line line1">
              <div v-if="lineShow >= 1"  class="progress" :style="{'width': lineShow === 1 ? lineWidth : '100%'}"></div><img v-if="lineShow === 1"  :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
            <div class="progress-gap" ><img :src="getPic(lineShow > 1 ? `progress_dotted` : `progress_dot`, 'png')" alt="" class="dot"><img :src="getPic(`50000Pkg`, 'png')" alt="" class="gift gift1"></div>
            <div class="line line2">
              <div v-if="lineShow >= 2" class="progress" :style="{'width': lineShow === 2 ? lineWidth : '100%'}"></div><img v-if="lineShow === 2" :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
            <div class="progress-gap"><img :src="getPic(lineShow > 2 ? `progress_dotted` : `progress_dot`, 'png')" alt="" class="dot"><img :src="getPic(`100000Pkg`, 'png')" alt="" class="gift gift2"></div>
            <div class="line line3">
              <div v-if="lineShow >= 3" class="progress" :style="{'width': lineShow === 3 ? lineWidth : '100%'}"></div><img v-if="lineShow === 3" :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
            <div class="progress-gap"><img :src="getPic(lineShow > 3 ? `progress_dotted` : `progress_dot`, 'png')" alt="" class="dot"><img :src="getPic(`500000Pkg`, 'png')" alt="" class="gift gift3"></div>
            <div class="line line4">
              <div v-if="lineShow >= 4" class="progress" :style="{'width': lineShow === 4 ? lineWidth : '100%'}"></div><img v-if="lineShow === 4" :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
            <div class="progress-gap"><img :src="getPic(lineShow > 4 ? `progress_dotted` : `progress_dot`, 'png')" alt="" class="dot"><img :src="getPic(`1000000Pkg`, 'png')" alt="" class="gift gift4"></div>
            <div class="line line5">
              <div v-if="lineShow >= 5" class="progress" :style="{'width': lineShow === 5 ? lineWidth : '100%'}"></div><img v-if="lineShow === 5" :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
          </div>
        </div>
      </div>
      <div class="txjw" ref="nav1">
        <div class="fixed-inner">
          <div class="news">
            <div class="news-left">
              <div class="news-left-head">
                <div class="news-left-head-inner">
                  <div class="news-left-head-item" v-for="(item, index) in newsHead"
                       :class="{'checked': index === newsIndex}" @click.stop="chooseNews(index)">
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="news-left-list">
                <div v-for="(item, index) in newsData[newsIndex]" class="news-left-list-item" @click.stop="openNews(item)">
                  <div class="cate">【{{ newsHead[item.noticeType] }}】</div>
                  <div class="cont">{{ item.noticeTitle }}</div>
                  <div class="date">{{ getDate(item.updateTime || item.createTime) }}</div>
                </div>
              </div>
            </div>
            <div class="news-right">
              <homeSwiper
                  id="bannerSwiper1"
                  v-if="newsDataPic.length>0"
                  :type="1"
                  :banner-list="newsDataPic"
                  pagination-align="center"
                  query-selector="#bannerSwiper1"/>
            </div>
          </div>
        </div>
      </div>
      <div ref="nav2" class="xkz">
        <div class="fixed-inner">
          <div class="roles">
            <template v-for="(role, index) in roleData">
              <div class="role">
                <div class="role-left" @click.stop="selectRoleCate(index)">
                  <img v-show="index !== selectRoleCateIndex" class="imgPre" :src="getPic(role.name,'png')" width="100%"
                       alt="">
                  <img v-show="index === selectRoleCateIndex" class="imgClick" :src="getPicClick(role.name)" width="100%"
                       alt="">
                </div>
                <div v-show="index === selectRoleCateIndex" class="role-detail">
                  <div class="fixed-box">
                    <div class="label career">职业介绍:</div>
                    <div class="label hard">操作难度:</div>
                    <div class="label property">主要属性:</div>
                    <div class="label element">元素专精:</div>
                    <div class="label skill">技能:</div>
                    <img class="rloeIcon" :src="getPic(`${role.name}Icon`, 'png')" width="100%" alt="">
                  </div>
                  <transition name="fade" mode="out-in">
                    <div v-show="index === selectRoleCateIndex" class="role-content">
                      <div class="role-pic" >
                        <img  :class="`${role.name}`" :src="getPicLink(`role_${role.picName}.png`)" width="100%" alt="">
                      </div>
                      <div class="role-cont">
                        <div class="name">
                          <img :src="getPic(`${role.name}Title`, 'png')" width="100%" alt="">
                        </div>
                        <div class="career">
                          <div class="words">{{ role.detail }}</div>
                        </div>
                        <div class="hard">
                          <div class="words">{{ role.hard }}</div>
                        </div>
                        <div class="property">
                          <div class="words">{{ role.property }}</div>
                        </div>
                        <div class="element">
                          <div class="words">{{ role.element }}</div>
                        </div>
                        <div class="skill">
                          <img :src="getPic(`${role.name}Skill`, 'png')" width="100%" alt="">
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div ref="nav3" class="jhfg">
        <div class="fixed-inner">
          <div class="box4">
            <homeSwiper
                id="bannerSwiper2"
                v-if="box4Pic.length>0"
                :type="2"
                :banner-list="box4Pic"
                :pn-btn="true"
                pagination-align="center"
                query-selector="#bannerSwiper2"/>
          </div>
        </div>
      </div>
      <div class="box-bottom">
        <div v-for="(item, index) in bottomLink" :class="`url${index+1}`" @click.stop="openOthers(item)">
          {{item.name}}
        </div>
        <div class="beian0">
          <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank"></a>
        </div>
        <div class="beian">
          <img :src="getRolePic('beian','png')" alt="">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51019002007896" rel="noreferrer" target="_blank">川公网安备51019002007896号</a>
        </div>
      </div>
    </div>
    <div v-if="openToast>0" class="toastContent">
      <div v-if="openToast===1" class="bookToast">
        <div class="head">游戏预约</div>
        <div class="close" @click.stop="closeToast">×</div>
        <div class="cates">
          <div class="cate" :class="{'selected': choosedType === 1}" @click.stop="chooseType(1)">
            Android
          </div>
          <div class="cate" :class="{'selected': choosedType === 2}" @click.stop="chooseType(2)">
            ios
          </div>
        </div>
        <div class="input">
          <label for="input_mobile_number" @click.stop="inputFocus('input_mobile_number')">
            <input
                v-model="mobileNum"
                id="input_mobile_number"
                ref="input_mobile_number"
                type="tel"
                class="input_mobile_number"
                placeholder="请输入手机号码"
                autocomplete="off"
                @change="changeValue"
                @input="mobileMaxLength"
            />
          </label>
          <label for="verify_mobile_number" @click.stop="inputFocus('verify_mobile_number')">
            <input
                v-model="verifyNum"
                id="verify_mobile_number"
                ref="verify_mobile_number"
                type="text"
                class="verify_mobile_number"
                placeholder="请输入验证码"
                autocomplete="off"
                @input="maxLength"
            />
            <div class="getVerifyNum" @click.stop="getVerifyNum">{{ interval_seconds > 0 ? `${interval_seconds}S` : '获取验证码' }}</div>
          </label>

        </div>
        <div class="next_step" @click.stop="getBooking">立即预约</div>
<!--        <div class="agreePolicy">-->
<!--          <div class="select iconfont icon-duigou selected"></div>-->
<!--          我已详细阅读并同意 <span @click.stop="openUserTerm">《用户协议》</span>-->
<!--          和 <span @click.stop="openPrivacyTerm">《隐私政策》</span>-->
<!--        </div>-->
      </div>
      <div v-if="openToast === 4" class="successToast">
        <div class="close" @click.stop="closeToast">×</div>
        <div class="successIcon iconfont" :class="{'icon-duigouxuanzhong' : iconfontClass, 'icon-cuochayuankuangtianchong': !iconfontClass}"></div>
        <div class="title">{{successText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import role from '@/json/role.json'

export default {
  name: 'Home',
  data() {
    return {
      navs: role.navs,
      navFocusFlag: -1,
      newsHead: ['最新', '新闻', '公告', '活动'],
      newsIndex: -1,
      newsData: {},
      newsDataAll: [],
      newsDataLen: 0,
      newsDataPic: ['news0','news1'],
      roleData: role.cate,
      selectRoleCateIndex: 1,
      selectRoleIndex: 0,
      roleIndex: 0,
      bookings: role.bookings,
      link1: role.link1,
      link2: role.link2,
      outLink: role.outLink,
      bookProgress: role.bookProgress,
      bottomLink: role.bottomLink,
      mobileNum: '',
      verifyNum: '',
      openToast: 0,
      newsPic: role.newsPic,
      box4Pic: role.box4Pic,
      inputBarrage: '',
      gzhShowFlag: false,
      choosedType: 1,
      sent: false,
      hoverBooking: '',
      hoverDownload: '',
      lineWidth: '0',
      lineShow: 0,
      interval_seconds: -1,
      intervalObj: null,
      successText:'',
      iconfontClass: true,
      autoChangeObj: null
    }
  },
  created() {
    this.getLineWidth();
  },
  mounted() {
    this.getNews();
    this.getNewsPic();
    this.autoChangeRole();
  },
  watch: {
    newsDataLen(n) {
      if (n === 3) {
        let data = [];
        for (let j = 0, len = this.newsDataAll.length; j < len; j++) {
          data.push({
            ...this.newsDataAll[j],
            time: this.getDateTime(this.newsDataAll[j].updateTime || this.newsDataAll[j].createTime)
          });
        }
        data.sort((a, b) => a.time - b.time);
        this.$set(this.newsData, 0, data.slice(0, 4));
        this.newsIndex = 0;
      }
    }
  },
  methods: {
    navFocus(index) {
      this.navFocusFlag = index;
    },
    clickBooking(item) {
      // if (type === 'Off') {
      //   this.openToast = 1;
      // }
      window.open(item, '_blank');
    },
    enterBooking(type) {
      this.hoverBooking = type;
    },
    enterDownload(type) {
      this.hoverDownload = type;
    },
    chooseNews(index) {
      this.newsIndex = index;
    },
    openNews(item){
      this.$router.push({
        name: 'news',
        params: {news: item, type: 'pc'}
      }).catch(() => {});
    },
    getDate(foo) {
      const date1 = foo.split(` `)[0], date2 = date1.split('-');
      return date2[1] + '-' + date2[2];
    },
    getRolePic(pic) {
      return require(`role/${pic}.png`);
    },
    getPic(pic, type) {
      return require(`img/${pic}.${type}`);
    },
    getPicClick(pic) {
      return require(`img/${pic}Click.png`);
    },
    //切换角色
    selectRoleCate(index) {
      clearInterval(this.autoChangeObj);
      this.selectRoleCateIndex = index;
      this.autoChangeRole();
    },
    autoChangeRole() {
      clearInterval(this.autoChangeObj);
      this.autoChangeObj = setInterval(()=>{
        if (this.selectRoleCateIndex < 3) {
          this.selectRoleCateIndex++;
        } else {
          this.selectRoleCateIndex = 0;
        }
      }, 4000)
    },
    changeRole(gap) {
      const len = this.roleData[this.selectRoleCateIndex].list.length;
      if (gap > 0 && this.selectRoleIndex < len - 1 || gap < 0 && this.selectRoleIndex > 0) {
        this.selectRoleIndex += gap;
      }
    },
    inputFocus(name) {
      if (this.$refs[name]) {
        this.$refs[name].focus();
      }
    },
    //底部跳转链接
    openOthers(item) {
      if (item.pic && item.pic === 'gzh') {
        this.gzhShowFlag = true;
      } else {
        //window.open(item.link, '_blank');
        this.$router.push({
          name: item.router
        }).catch(() => {});
      }
    },
    //官网预约
    maxLength() {
      if (this.verifyNum.length > 6) {
        this.verifyNum = this.verifyNum.slice(0, 6);
      }
    },
    changeValue(event) {
      this.mobileNum = event.target.value;
    },
    mobileMaxLength() {
      if (this.mobileNum.length > 11) {
        this.mobileNum = this.mobileNum.slice(0, 11);
      }
    },
    openUserTerm() {
      window.open(this.outLink.userTerm, '_blank');
    },
    openPrivacyTerm() {
      window.open(this.outLink.privacyTerm, '_blank');
    },
    getPicLink(name) {
      return this.outLink.picUrl + name;
    },
    bookingSuccessToast(txt, flag) {
      this.successText = txt;
      this.iconfontClass = flag
      this.openToast = 4;
      setTimeout(()=>{
        this.closeToast();
      }, 2000);
    },
    closeToast() {
      this.sent = false;
      this.choosedType = 1;
      this.openToast = 0;
    },
    scrollDom(ref) {
      if (ref === 4) {
        window.open('https://fanyukaitian.com.cn', '_blank');
        return;
      }
      this.$refs[`nav${ref}`].scrollIntoView();
    },
    getNews() {
      for (let i = 1; i < 4; i++) {
        api.sendGetRequest('newsList', {noticeType: i}, (isSuccess, data, err) => {
          if (isSuccess) {
            if (data.code === 200) {
              this.newsData[i] = data.rows;
              this.newsDataAll = this.newsDataAll.concat(data.rows);
              this.newsDataLen++;
            }
          } else {
            console.log(err.errorMsg);
          }
        });
      }
    },
    getNewsPic() {
      api.sendGetRequest('getNewsPic1', {}, (isSuccess, data, err) => {
        if (isSuccess) {
          this.newsDataPic = data;
        } else {
          console.log(err.errorMsg);
        }
      });
    },
    getDateTime(date) {
      const foo = new Date(date);
      return foo.getTime();
    },
    compareTime(item1, item2) {
      if (!item2) {
        return item1;
      }
      const time1 = this.getDateTime(item1.updateTime || item1.createTime);
      const time2 = this.getDateTime(item2.updateTime || item2.createTime);
      return item1 > time2 ? item1 : item2;
    },
    getVerifyNum() {
      if (this.interval_seconds > 0) {
        return;
      }
      this.sent = true;
      const params = {
        phone: this.mobileNum,
        type: this.choosedType
      };
      api.sendRequest('sendCode', params, (isSuccess, data, err) => {
        if (isSuccess) {
          if (data.code === 0) {
            this.interval_seconds = 60;
            this.intervalObj = setInterval( ()=>{
              if ( this.interval_seconds > 0 ) {
                this.interval_seconds--;
              } else {
                clearInterval( this.intervalObj );
              }
            }, 1000 );
          } else {
            this.bookingSuccessToast(data.msg, false);
          }
        } else {
          console.log(err.errorMsg);
        }
      });
    },
    getBooking() {
      const params = {
        phone: this.mobileNum,
        code: this.verifyNum,
        type: this.choosedType
      };
      api.sendRequest('booking', params, (isSuccess, data, err) => {
        if (isSuccess) {
          if (data.code === 0) {
            this.bookingSuccessToast('您已成功预约游戏！', true);
          } else {
            this.bookingSuccessToast(data.msg, false);
          }
        } else {
          console.log(err.errorMsg);
        }
      });
    },
    chooseType(type) {
      this.choosedType = type;
    },
    getLineWidth() {
      const nowDate = new Date(),
          startDate= new Date("2025-04-01 00:00:00"),
          date5 = new Date("2025-04-07 00:00:00"),
          date10 = new Date("2025-04-14 00:00:00"),
          date50 = new Date("2025-04-21 00:00:00"),
          date100 = new Date("2025-05-06 00:00:00");
      let lineWidth = 0;
      if (nowDate > date100) {
        this.lineShow = 5;
        lineWidth = 0;
      } else if (nowDate > date50) {
        this.lineShow = 4;
        lineWidth =  4.2*(nowDate - date50)/(date100 - date50);
      } else if (nowDate > date10) {
        this.lineShow = 3;
        lineWidth = 3.2*(nowDate - date10)/(date50 - date10);
      } else if (nowDate > date5) {
        this.lineShow = 2;
        lineWidth = 2.2*(nowDate - date5)/(date10 - date5);
      } else {
        this.lineShow = 1;
        lineWidth = 1.1*(nowDate - startDate)/(date5 - startDate);
      }
      this.lineWidth = lineWidth.toFixed(3)+'rem';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "~styles/index.less";

.content-box {
  width: 19.2rem;

  .bg_img1 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 54.28rem;
    z-index: 1;

    .head_nav {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 0.78rem;
      z-index: 1000;

      .logo{
        float: left;
        margin: -0.35rem 0 0 0;
        width: 2.36rem;
        height: auto;
      }

      .nav-btn-outer{
        display: flex;
        margin-left: 3.31rem;
        width: 12.6rem;
        height: 0.78rem;
        align-items: center;
        justify-content: space-between;

        .nav {
          width: auto;
          height: 100%;
          font-weight: 400;
          font-size: 0.24rem;
          color: #B6D0EB;
          line-height: 0.78rem;
          text-align: center;
          cursor: pointer;
          font-family: STZhongsong;

          &.nav_focus {
            color: #C7A957;
          }
        }
      }
    }

    .webTitle {
      position: absolute;
      top: 3rem;
      left: 6rem;
      width: 8.8rem;
      height: 4.4rem;
      .background('https://scszsj-system.oss-cn-beijing.aliyuncs.com/pic0/bannerLogo.png');
      z-index: -1;
    }

    .rightSides{
      position: fixed;
      right: 0;
      top: 5.1rem;
      width: 1.86rem;
      z-index: 100;
      img{
        width: 100%;
      }
      .erweima{
        position: absolute;
        width: 1.2rem;
        height: auto;
        left: .55rem;
        top: .82rem;
        z-index: 2;
      }
    }

    .download {
      margin-top: 7.8rem;
      margin-left: 8rem;
      padding-top: .1rem;
      width: 5.46rem;
      height: 2.38rem;
      .background('~role/downloadBtn.png');

      .download_ercode{
        float: left;
        margin-top: .06rem;
        margin-left: .19rem;
        width: 2.02rem;
        height: 2.02rem;
        .background('~role/downloadERC.png');
      }

      .downloadBtn {
        margin-left: 3rem;
        width: 2.2rem;
        height: 0.72rem;
        cursor: pointer;
      }
    }

    .fixed-inner{
      margin-top:  .95rem;
      width: 100%;
      position: relative;
    }

    .bookProgress {
      .clr();
      top: 13rem;
      width: 13rem;
      height: 7.85rem;

      .levels {
        width: 100%;
        height: 4rem;

        .level {
          position: absolute;
          width: 2.63rem;
          height: auto;

          .num {
            width: 100%;
            height: .5rem;
            line-height: .5rem;
            font-family: FZBaoHeiTiS;
            font-weight: 800;
            font-size: .48rem;
            color: #CCA711;
          }

          img {
            width: 100%;
            height: 3.7rem;
          }

          &.level20 {
            left: 1.7rem;
            top: .36rem;
          }

          &.level60 {
            left: 5.6rem;
            top: 1.46rem;
          }

          &.level100 {
            left: 9.7rem;
            top: .4rem;
          }
        }
      }

      .progressLine {
        position: relative;
        width: 12rem;
        height: auto;
        .clr();
        margin-top: 1.6rem;

        .line-box {
          position: absolute;
          left: -.1rem;
          top: .46rem;
          width: 12.1rem;
          height: .1rem;
          display: flex;
          align-items: center;

          .line {
            position: relative;
            height: .02rem;
            background: #D9CD9F;
            display: flex;
            align-items: center;
            justify-content: left;
            .progress{
              width: 50%;
              height: .022rem;
              background: #E4C161;
            }
            .bookProgressArrow{
              margin-left: -0.06rem;
              width: 0.3rem;
              height: .22rem;
            }

            &.line1, &.line5{
              width: 1.1rem;
            }
            &.line2{
              width: 2.2rem;
            }
            &.line3{
              width: 3.2rem;
            }
            &.line4{
              width: 4.2rem;
            }
          }

          .progress-gap{
            position: relative;
            width: 0.2rem;
            height: 0.2rem;
            margin: 0 .04rem;

            .dot{
              display: inline-block;
              width: 0.2rem;
              height: 0.2rem;
            }
            .gift{
              position: absolute;
              bottom: -.6rem;

              &.gift1{
                width: 1.42rem;
                left: -.5rem;
              }
              &.gift2{
                width: 1.58rem;
                left: -.58rem;
              }
              &.gift3{
                width: 1.6rem;
                left: -.58rem;
              }
              &.gift4{
                width: 1.74rem;
                left: -.6rem;
              }
            }
          }
        }
      }
    }

    .txjw {
      position: absolute;
      top: 20rem;
      width: 100%;

      .news {
        .clr();
        top: 1rem;
        width: 13.2rem;
        height: 3.32rem;

        .news-left {
          position: absolute;
          top: 1.3rem;
          left: 1.6rem;
          width: 6.2rem;
          height: 3.95rem;

          .news-left-head {
            width: 3.8rem;
            height: .76rem;

            .news-left-head-inner {
              display: flex;
              width: 3.8rem;
              height: 100%;
              margin-left: 0.1rem;
              justify-content: space-between;

              .news-left-head-item {
                position: relative;
                margin-top: .1rem;
                width: 1.4rem;
                height: .75rem;
                font-weight: 400;
                font-size: 0.24rem;
                color: #FFFFFF;
                line-height: 0.76rem;
                cursor: pointer;
              }

              .news-left-head-item.checked {
                color: rgba(199, 169, 87, 1);
              }
            }
          }

          .news-left-list {
            .clr();
            width: 5.74rem;
            height: 2rem;
            overflow-y: scroll;

            .news-left-list-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              height: .6rem;
              line-height: .6rem;
              cursor: pointer;

              .cate {
                width: .8rem;
                font-family: Source Han Serif CN;
                font-weight: 500;
                font-size: .2rem;
                color: rgba(109, 115, 121, 1);
                white-space: nowrap;
              }

              .cont {
                width: 4.2rem;
                font-weight: 500;
                font-size: .18rem;
                font-family: Source Han Serif CN;
                color: rgba(109, 115, 121, 1);
                text-align: left;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }

              .date {
                width: 1rem;
                font-weight: 500;
                font-family: Source Han Serif CN;
                font-size: .16rem;
                color: rgba(109, 115, 121, 1);
              }
            }
          }
        }

        .news-right {
          .setPos_top_right(22, 50);
          width: 5.88rem;
          height: 6.26rem;
          padding: .05rem 0 0 .06rem;
        }
      }
    }

    .xkz {
      position: absolute;
      top: 29.2rem;
      width: 100%;
      height: 10.9rem;
      overflow: hidden;
      font-family: STZhongsong;

      .roles {
        .clr();
        top: 1.6rem;
        width: 13.2rem;
        height: 6rem;

        .role {
          .role-left {
            position: relative;
            width: 2.1rem;
            height: 1.5rem;
            margin-bottom: .2rem;
            margin-left: -.3rem;
            z-index: 2;

            .imgPre {
              width: 1.2rem;
              height: 1.2rem;
              .clr();
              cursor: pointer;
            }

            .imgClick {
              width: 1.2rem;
              height: 1.2rem;
              .clr();
              cursor: pointer;
            }
          }

          .role-detail {
            position: absolute;
            top: 0;
            right: 0;
            width: 11.4rem;
            height: 9rem;

            .fixed-box{
              position: absolute;
              right: 0;
              top:0;
              width: 3.8rem;
              height: 9rem;
              z-index: 2;

              .label {
                margin-right: .2rem;
                width: 1.4rem;
                height: .28rem;
                line-height: .28rem;
                text-align: left;
                border-radius: .26rem;
                font-family: STZhongsong;
                font-size: .24rem;
                color: #C7A957;

                &.career{
                  margin-top: 1.2rem;
                }
                &.hard{
                  margin-top: 1.7rem;
                }
                &.property{
                  margin-top: .14rem;
                }
                &.element{
                  margin-top: .14rem;
                }
                &.skill{
                  margin-top: .7rem;
                }
              }
              .rloeIcon{
                position: absolute;
                right: -.4rem;
                top: -1.4rem;
                width: 2.7rem;
              }
            }

            .fade-enter-active {
              transition: all 1.5s;
            }

            .fade-leave-active {
              transition: all 0s;
            }

            .fade-leave, .fade-leave-to {
              opacity: 0;
            }

            .fade-enter, .fade-enter-from {
              opacity: 1;
              transform: translateX(2rem);
            }

            .role-content{
              position: relative;
              .role-pic {
                margin-left: -1.5rem;
                margin-top: -0.7rem;
                width: auto;
                height: 9rem;
                position: relative;

                img {
                  width: 18rem;
                  position: absolute;
                  left: -3rem;
                  top: -2.2rem;
                }

                .yingren{
                  left: -1.4rem;
                  top: -2.2rem;
                }
                .jianshi{
                  left: -4.8rem;
                  top: -5rem;
                }
                .youxia{
                  left: -3rem;
                  top: -3.6rem;
                }
              }

              .role-cont {
                position: absolute;
                top: 0;
                right: 0;
                width: 3.8rem;
                height: 9rem;
                text-align: left;

                .words {
                  font-family: STZhongsong;
                  font-size: .18rem;
                  color: #fff;
                }

                .name {
                  margin-top: .6rem;
                  width: 2rem;
                  height: 1.1rem;
                  overflow: hidden;
                  img {
                    width: 2rem;
                  }
                }

                .career {
                  margin-top: .26rem;
                  .words {
                    padding-top: .3rem;
                    line-height: .28rem;
                    width: 3.2rem;
                    height: 1.4rem;
                  }
                }

                .hard,.property,.element {
                  .words{
                    padding-left: 1.2rem;
                  }
                }
                .hard{
                  margin-top: .3rem;
                }
                .property {
                  margin-top: .2rem;
                }
                .element {
                  margin-top: .2rem;
                }
                .skill {
                  margin-top: 1.2rem;
                  margin-left: -.1rem;
                  img{
                    width: 100%;
                  }
                }
              }
            }

          }

        }
      }
    }

    .jhfg {
      position: absolute;
      top: 40.2rem;
      width: 100%;

      .box4 {
        .wh(1440, 624);
        .clr();
        top: 1.4rem;
      }
    }

    .box-bottom{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      .url1{
        position: absolute;
        bottom: 2.5rem;
        left: 3.36rem;
        cursor: pointer;
        font-family: FZYaSongS-B-GB;
        font-weight: 400;
        font-size: 0.2rem;
        color: #D9C9A0;
      }
      .url2{
        position: absolute;
        bottom: 2.5rem;
        left: 4.56rem;
        cursor: pointer;
        font-family: FZYaSongS-B-GB;
        font-weight: 400;
        font-size: 0.2rem;
        color: #D9C9A0;
      }
      .beian0{
        position: absolute;
        bottom: 1.4rem;
        left: 3.36rem;
        width: 4rem;
        height: .2rem;
        line-height: .2rem;
        cursor: pointer;
        a{
          display: inline-block;
          margin-left: .1rem;
          width: 100%;
          height: 100%;
        }
      }
      .beian{
        position: absolute;
        bottom: .7rem;
        left: 3.36rem;
        height: .2rem;
        line-height: .2rem;
        cursor: pointer;
        img{
          height: 100%;
          margin-left: .1rem;
        }
        a{
          display: inline-block;
          margin-left: .1rem;
          width: auto;
          font-family: FZYaSongS-B-GB;
          font-weight: 400;
          font-size: 0.2rem;
          color: #4D4D4D;
        }
      }
    }
  }

  .toastContent {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 2;
    background: rgba(25, 25, 25, .6);

    .bookToast {
      position: absolute;
      top: 3.93rem;
      left: 7.11rem;
      width: 4.99rem;
      height: 3.97rem;
      background: #EFF2F5;

      .head {
        margin: .28rem 0 .42rem;
        width: 100%;
        height: .45rem;
        font-family: STZhongsong;
        font-weight: 400;
        font-size: 0.45rem;
        color: #585858;
        line-height: .45rem;
        text-align: center;
      }

      .close {
        position: absolute;
        right: .13rem;
        top: .12rem;
        width: .17rem;
        height: .12rem;
        line-height: .12rem;
        color: #585858;
        font-size: .3rem;
        text-align: center;
        font-weight: bold;
        cursor: pointer;
      }

      .cates {
        width: 100%;
        height: .6rem;
        line-height: .6rem;
        display: flex;
        align-items: center;

        .cate {
          flex: 1;
          width: auto;
          height: .6rem;
          line-height: .6rem;
          cursor: pointer;
          font-size: .3rem;
          font-weight: 400;
          color: #646464;;
          background: #DADFE3;

          &.selected {
            color: #F1C333;
            background: #FFFFFF;
          }
        }
      }

      .input {
        margin-top: .37rem;
        padding-left: .36rem;
        width: 4.28rem;
        height: auto;

        label {
          display: flex;
          position: relative;
          width: 4.28rem;
          height: .36rem;
          margin-bottom: .17rem;
          align-items: center;

          input {
            box-sizing: border-box;
            width: 100%;
            height: .36rem;
            line-height: .36rem;
            border: .01rem solid #C9C9C9;
            background: transparent;
            font-family: STZhongsong;
            font-weight: 400;
            font-size: 0.18rem;
            color: #8C8E99;
            outline: none;
            text-align: center;

            &.verify_mobile_number{
              width: 2.84rem;
            }
          }

          .getVerifyNum {
            width: 1.3rem;
            height: .36rem;
            margin-left: .14rem;
            line-height: .36rem;
            font-family: Source Han Serif CN;
            font-weight: 500;
            font-size: .18rem;
            color: #585858;
            background: #F9F9F9;
            outline: .01rem solid #F0F0F0;
            outline-offset: -.04rem;
            cursor: pointer;

            &.sent {
              color: #818181;
            }
          }
        }

      }

      .next_step {
        margin-left: 1.69rem;
        margin-top: .28rem;
        width: 1.6rem;
        height: 0.39rem;
        background: linear-gradient(0deg, #F9CC3F 0%, #EFB310 99%);
        border-radius: 0.09rem;
        font-family: STZhongsong;
        font-weight: 400;
        font-size: 0.24rem;
        color: #352908;
        line-height: 0.39rem;
        text-align: center;
        cursor: pointer;
      }

      .agreePolicy {
        margin: .27rem 0 0 .3rem;
        width: 3.62rem;
        height: .3rem;
        font-family: Source Han Serif CN;
        font-weight: 500;
        font-size: .14rem;
        color: #818181;
        line-height: .3rem;
        display: flex;
        align-items: center;

        .select {
          margin-right: .1rem;
          width: .12rem;
          height: .12rem;
          border: .01rem solid #A9A9A9;

          &.selected {
            line-height: .14rem;;
            border-color: transparent;
            font-size: .14rem;
            color: rgba(245, 186, 59, 1);
          }
        }

        span {
          color: rgba(101, 152, 244, 1);
          font-size: .14rem;
          cursor: pointer;
        }
      }
    }

    .successToast{
      position: absolute;
      top: 3.2rem;
      left: 7.2rem;
      box-sizing: border-box;
      padding: .4rem;
      min-width: 5rem;
      width: auto;
      min-height: 3rem;
      background: #fefef5;
      border-radius: .12rem;

      .close {
        position: absolute;
        right: .3rem;
        top: .25rem;
        width: .2rem;
        height: .2rem;
        line-height: .2rem;
        color: rgba(131, 125, 110, 1);
        font-size: .36rem;
        text-align: center;
        font-weight: bold;
        cursor: pointer;
      }

      .successIcon{
        font-size: 1rem;
        color: #5fa964;
        text-align: center;
        margin: 0 0 .3rem;
      }

      .title{
        font-family: Source Han Serif CN;
        font-size: .4rem;
        line-height: .5rem;
        text-align: center;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/home.vue